export enum LogLevel {
  ERROR = 'error',
  WARN = 'warn',
  INFO = 'info',
  DEBUG = 'debug',
  TRACE = 'trace',
}

export interface LoggerOptions {
  namespace: string;
  level?: LogLevel;
  enabled?: boolean;
  color?: string;
}

export interface Logger {
  error: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
  trace: (...args: unknown[]) => void;
  enable: () => void;
  disable: () => void;
  isEnabled: () => boolean;
  getNamespace: () => string;
}

export interface LoggerConfig {
  level?: LogLevel;
  enabled?: string;
  formatTimestamp?: () => string;
  includeTimestamp?: boolean;
}
